module.exports = __webpack_public_path__ + "img/footer_illustration_left.56dceb2e.svg";